module.exports = __webpack_public_path__ + "img/6.11d92f35.jpg";